import { User } from "firebase/auth"
import { SpaceDocumentMeta, SpaceKey } from "popopo-msg"
import { useForm } from "react-hook-form"
import React from "react"
import { api, firestore } from "../../core"
import { usePublicSpaceBackgroundsForAdmin } from "popopo-lib-front/firestore-access"
import { useToast } from "popopo-lib-front/hook"

type SpaceBackgroundUpdateForms = {
  backgroundId: string
}

export const SpaceBackgroundUpdateForm = (props: { firebase: User; spaceKey: SpaceKey; backgroundConfiguration: SpaceDocumentMeta["background"] }) => {
  const toast = useToast()
  const spaceBackground = usePublicSpaceBackgroundsForAdmin(firestore)

  const form = useForm<SpaceBackgroundUpdateForms>({
    mode: "onBlur",
    defaultValues: {
      backgroundId: props.backgroundConfiguration.id,
    },
  })
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SpaceBackgroundUpdateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.PUT("/api/v2/spaces/{space_key}/background", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          background: {
            id: value.backgroundId,
            kind: "shared",
          },
        },
      })
      if (res.error) {
        toast.add({ type: "danger", title: "背景変更", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "背景変更", message: e })
    }
  }
  return (
    <form className="d-flex flex-column gap-3 w-100" onSubmit={form.handleSubmit(onSubmit)}>
      <div className="form-floating">
        {spaceBackground !== "loading" ? (
          <select
            className="form-select"
            {...form.register("backgroundId", { required: true })}
          >
            {spaceBackground.map((background) => (
              <option key={background.id} value={background.id}>
                {background.name}
              </option>
            ))}
          </select>
        ) : (
          <p>背景を読込中</p>
        )}
        <label>背景</label>
      </div>

      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        Call &quot;PUT /spaces/:spaceKey/background&quot; API
      </button>
    </form>
  )
}
